import styled from 'styled-components/macro';
import TabButton from '~/components/Tab/TabButton';

export const Title = styled.div`
  background-color: ${({ theme }) => theme.dark};
  font-size: 20px;
  color: ${({ theme }) => theme.white};
  font-family: ${({ theme }) => theme.primaryFontMedium};
  text-transform: uppercase;
  padding: 34px 15px 15px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 15px;
    padding: 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 48px;
  padding-bottom: 57px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0px;
  }
  &::before {
    content: '';
    background-color: ${({ theme }) => theme.dark};
    width: 100%;
    height: 297px;
    top: 0px;
    right: 0;
    position: absolute;
    z-index: 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
      height: 291px;
    }
  }
`;

export const TableContent = styled.div`
  z-index: 10;
  width: 100%;
  table {
    @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
      margin-top: 30px;
    }
    thead {
      th {
        padding-left: 0px;
        padding-right: 0px;
        position: relative;
        @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
          &:first-child {
            opacity: 0;
          }
        }
        & > div {
          text-transform: uppercase;
          text-align: left;
          color: ${({ theme }) => theme.coral};
          align-items: center;
          justify-content: center;
          height: 200px;
          @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
            align-items: start;
            height: 232px;
            max-width: 44px;
          }
          svg {
            margin-left: -10px;

            &:first-child {
              margin-left: 10px;
            }

            polygon {
              fill: ${({ theme }) => theme.coral};
            }
          }
        }
      }
    }
    tbody,
    tfoot {
      td {
        &:first-child {
          text-align: left;
        }
      }
    }
    th,
    td {
      text-align: center;
      font-family: ${({ theme }) => theme.primaryFontLight};
      &:nth-child(2n) {
        font-family: ${({ theme }) => theme.primaryFontBold};
      }
    }
  }
`;

export const SeasonHeader = styled.span`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  color: ${({ theme }) => theme.white};
`;

export const Total = styled.span`
  text-transform: uppercase;
`;

export const AvatarHeader = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 10px;
  transition: opacity 0.3s;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.6)};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0px;
  }
`;

export const RefereeRole = styled.p`
  height: 57px;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  color: ${({ theme }) => theme.white};
  order: 3;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 9px;
    height: 38px;
    order: 1;
  }
`;

export const RefereeName = styled.p`
  font-family: ${({ theme }) => theme.primaryFontLight};
  color: ${({ theme }) => theme.white};
  text-transform: capitalize;
  font-size: ${({ theme }) => theme.paragraphSmall}px;
  order: 1;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    text-align: center;
    order: 3;
    font-size: 9px;
    position: absolute;
    width: 100px;
    bottom: 0px;
    transform-origin: 100% 0%;
    transform: rotateZ(49deg) translateX(-50%);
    text-align: right;
    left: -37%;
  }
`;

export const AvatarPhoto = styled.img`
  width: 65px;
  height: 97px;
  margin: 3px 0px;
  object-fit: cover;
  order: 2;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin: 0px 0px 8px 0px;
    width: 49px;
    height: 72px;
  }
`;

export const ContainerArbitration = styled.div`
  flex-grow: 1;
  height: 100%;
  background-color: ${({ theme }) => theme.white};
  min-height: 100%;
`;

export const AssistanceListContent = styled.div``;

export const TabButtonFullWidth = styled(TabButton)`
  justify-content: space-between;
  padding: 8px;
  background-color: ${({ theme, isOpen }) =>
    isOpen ? theme.dark : theme.black};
  border-top: solid 1px ${({ theme }) => theme.white};
`;
export const ProfileImg = styled.img`
  grid-area: image;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfileRole = styled.div`
  grid-area: role;
  font-size: 15px;
  font-family: ${({ theme }) => theme.primaryFontLight};
`;

export const ProfileName = styled.div`
  grid-area: name;
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: 16px;
`;

export const ContainerProfile = styled.div`
  display: grid;
  grid-template-columns: 41px auto;
  grid-template-rows: 31px 31px;
  grid-template-areas:
    'image role'
    'image name';
  text-align: left;
  grid-column-gap: 20px;
`;

export const ListContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TabContent = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0px')};
  overflow: hidden;
  transition: max-height 0.3s;
`;
